import { get, post, upload, deletee } from ".";

const signIn = (payload) => {
  const request = {
    subUrl: "login",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const mobileSendOtp = (payload) => {
  const request = {
    subUrl: "requestotp",
    data: payload,
    isAuth: true,
  };
  return post(request);
};
const emailSendOtp = (payload) => {
  const request = {
    subUrl: "sendotpemail",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const signOut = (payload) => {
  const request = {
    subUrl: "logout",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const verifyOtp = (payload) => {
  const request = {
    subUrl: "verifyotp",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const registerUser = (payload) => {
  const request = {
    subUrl: "register2",
    data: payload,
    isAuth: true,
  };
  return post(request);
};
const registerProfessional = (payload) => {
  const request = {
    subUrl: "registerprofessional",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const registerCorporateUser = (payload) => {
  const request = {
    subUrl: "registercorporateuser",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const registerNriUser = (payload) => {
  const request = {
    subUrl: "registernriuser",
    data: payload,
    isAuth: true,
  };
  return post(request);
}

const registerEmitraUser = (payload) => {
  const request = {
    subUrl: "registeremitra",
    data: payload,
    isAuth: true,
  };
  return post(request);
}

const emitraRegisterClient = (payload) => {
  const request = {
    subUrl: "emitra-register-client",
    data: payload,
    isAuth: true,
  };
  return post(request);
}

const forgotPassword = (payload) => {
  const request = {
    subUrl: "forgot-password",
    data: payload,
    isAuth: true,
  };
  return post(request);
}

const resetPassword = (payload) => {
  const request = {
    subUrl: "reset-password",
    data: payload,
    isAuth: true,
  };
  return post(request);
}

const changePassword = (payload) => {
  const request = {
    subUrl: "change-password",
    data: payload,
    isAuth: true,
  };
  return post(request);
}

const uploadProfessionalDocuments = (formData) => {
  return upload({
    subUrl: "Attachments/upload-professional-certificates",
    data: formData,
    isAuth: false,
  });
}

const getOrganizations = () => {
  const request = {
    subUrl: "getorganizations",
    isAuth: true,
  };
  return get(request);
}

const deleteProfile = (payload) => {
  const request = {
    subUrl: "delete-profile",
    data: payload,
    isAuth: true,
  };
  return deletee(request);
}


const googleLogin = (payload) => {
  const request = {
    subUrl: "google-login",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const googleRequestMobileOtp = (payload) => {
  const request = {
    subUrl: "google-request-mobile-otp",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const googleCompleteOnboarding = (payload) => {
  const request = {
    subUrl: "google-complete-onboarding",
    data: payload,
    isAuth: true,
  };
  return post(request);
};

const authApi = {
  signIn,
  signOut,
  verifyOtp,
  mobileSendOtp,
  emailSendOtp,
  googleLogin,
  googleRequestMobileOtp,
  googleCompleteOnboarding,
  registerProfessional,
  registerUser,
  registerCorporateUser,
  forgotPassword,
  resetPassword,
  changePassword,
  uploadProfessionalDocuments,
  registerNriUser,
  getOrganizations,
  deleteProfile,
  registerEmitraUser,
  emitraRegisterClient,
};

export default authApi;

